import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import moment from 'moment';

import { getUser, updateUser } from '../../actions/admin/user';
import { updateModalContent, toggleModal } from '../../actions/modal';
import Images from '../basics/Images';

const Detail = ({
  getUser,
  id,
  updateUser,
  toggleModal,
  updateModalContent,
}) => {
  const [userData, setUserData] = useState({
    firstName:      '',
    lastName:       '',
    email:          '',
    address:        '',
    phone:          '',
    profileImage:   '',
    startDate:      null,
    qualifications: '',
    specialities:   '',
    proofOfAddress: '',
    type:           0,
    status:         0,
    redirect:       false,
  });

  const {
    firstName,
    lastName,
    email,
    address,
    phone,
    profileImage,
    proofOfAddress,
    startDate,
    qualifications,
    specialities,
    status,
    redirect,
  } = userData;

  useEffect(() => {
    const fetchUserData = async () => {
      const user = await getUser(id);

      setUserData({
        firstName:      user.first_name,
        lastName:       user.last_name,
        email:          user.email,
        address:        user.address,
        phone:          user.phone,
        profileImage:   user.profile_image,
        startDate:      moment(user.start_date).format('MM-DD-YYYY'),
        qualifications: user.qualifications,
        specialities:   user.specialities,
        proofOfAddress: user.proof_of_address,
        type:           user.type,
        status:         user.status,
      });
    };

    fetchUserData();
  }, [id, getUser]);

  const onApproveSupervisor = (id) => {
    const data = {
      type:   1,
      status: 1,
    };

    updateModalContent({
      title:        'Are you sure?',
      content:      'This user will being a supervisor!',
      actionButton: {
        actionText: 'Yes, Accept',
        actionType: 'danger',
        action:     () => updateUser(data, id),
      },
      cancelText:       'No',
      closeAfterAction: true,
    });

    toggleModal();
  };

  const onApproveInstructor = (id) => {
    const data = {
      type:   2,
      status: 1,
    };

    updateModalContent({
      title:        'Are you sure?',
      content:      'This user will being a instructor!',
      actionButton: {
        actionText: 'Yes, Accept',
        actionType: 'danger',
        action:     () => updateUser(data, id),
      },
      cancelText:       'No',
      closeAfterAction: true,
    });

    toggleModal();
  };

  const renderApproveButton = () => {
    if (status === 2) {
      return (
        <button
          onClick={() => onApproveSupervisor(id)}
          className="btn btn-primary"
        >
          Approve
        </button>
      );
    }

    if (status === 3) {
      return (
        <button
          onClick={() => onApproveInstructor(id)}
          className="btn btn-primary"
        >
          Approve
        </button>
      );
    }

    return '';
  };

  return redirect ? (
    <Redirect to="/admin/user" />
  ) : (
    <>
      <div className="row form-group">
        <div className="col-md-3">First Name:</div>
        <div className="col-md-9">{firstName}</div>
      </div>
      <div className="row form-group">
        <div className="col-md-3">Last Name:</div>
        <div className="col-md-9">{lastName}</div>
      </div>
      <div className="row form-group">
        <div className="col-md-3">Email:</div>
        <div className="col-md-9">{email}</div>
      </div>
      <div className="row form-group">
        <div className="col-md-3">Address:</div>
        <div className="col-md-9">{address}</div>
      </div>
      <div className="row form-group">
        <div className="col-md-3">Phone:</div>
        <div className="col-md-9">{phone}</div>
      </div>
      <div className="row form-group">
        <div className="col-md-3">Profile image:</div>
        <div className="col-md-9">
          <img
            src={
              profileImage !== ''
                ? `/${profileImage}`
                : Images.Local.AvatarDefault
            }
            alt=""
            width="150px"
          />
        </div>
      </div>
      <div className="row form-group">
        <div className="col-md-3">Start date:</div>
        <div className="col-md-9">{startDate}</div>
      </div>
      <div className="row form-group">
        <div className="col-md-3">Qualifications:</div>
        <div className="col-md-9">{qualifications}</div>
      </div>
      <div className="row form-group">
        <div className="col-md-3">Specialities:</div>
        <div className="col-md-9">{specialities}</div>
      </div>
      <div className="row form-group">
        <div className="col-md-3">Proof of address:</div>
        <div className="col-md-9">
          <img src={`/${proofOfAddress}`} alt="" width="500px" />
        </div>
      </div>
      {renderApproveButton()}
    </>
  );
};

Detail.propTypes = {
  getUser:            PropTypes.func.isRequired,
  id:                 PropTypes.string.isRequired,
  updateUser:         PropTypes.func.isRequired,
  updateModalContent: PropTypes.func.isRequired,
  toggleModal:        PropTypes.func.isRequired,
};

export default connect(
  null,
  { getUser, updateUser, toggleModal, updateModalContent },
)(Detail);
